import { schedularAnnouncementActions } from './../../actions/constant';

const {
  DELETE_ANNOUNCEMENT_REQUEST,
  DELETE_ANNOUNCEMENT_SUCCESS,
  DELETE_ANNOUNCEMENT_FAILURE,
  DELETE_ANNOUNCEMENT_RESET,
} = schedularAnnouncementActions;

const initialState: object = {
  response: null,
  loading: false,
};
export const deleteAnnouncementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case DELETE_ANNOUNCEMENT_REQUEST: {
      return { ...state, loading: true };
    }

    case DELETE_ANNOUNCEMENT_SUCCESS: {
      return { ...state, response: action.payload, loading: false };
    }

    case DELETE_ANNOUNCEMENT_FAILURE: {
      return { ...state, response: action.payload, loading: false };
    }

    case DELETE_ANNOUNCEMENT_RESET:
      return initialState;

    default:
      return state;
  }
};
